<script>
export default {
  props: {
    news: {
      type: Object,
    },
  },
};
</script>

<template>
  <div>
    <router-link
      :to="{name: 'userpage', params: {type: 'profile', id: news.textParams[0]}}"
    >{{ news.textParams[1] }}
    </router-link>
    {{$t('news.template.opinion.archivedMadePublic.p1')}}
    <router-link
      :to="{name: 'OpinionView', params: {hash: news.textParams[2] }}">
      {{ news.textParams[3] }}
    </router-link>
    {{$t('news.template.opinion.archivedMadePublic.p2')}}
    {{ news.textParams[4] }}
    {{$t('news.template.opinion.archivedMadePublic.p3')}}
    <router-link :to="{name: 'ProposalView', params: {id: news.textParams[5]}}">
      {{news.textParams[6]}}
    </router-link>
    {{$t('news.template.opinion.archivedMadePublic.p4')}}
  </div>
</template>
